<template>
  <v-container id="depoimentos" fluid class="py-12 black">
    <v-row class="pt-6 text-center justify-center">
      <v-col cols="auto">
        <h3 class="body-1 font-weight-regular pt-3">
          <span class="poppins primary--text">sobre o treinamento vivencial</span>
        </h3>
        <h2 class="display-1 font-weight-medium pt-1">
          <span class="barlow white--text">VEJA O QUE OS PARTICIPANTES DISSERAM</span>
        </h2>
        <v-divider class="mx-auto primary my-4" style="width: 50px; border: 2px solid"></v-divider>
      </v-col>
    </v-row>
    <v-row
      class=""
      :class="{
        'px-12': $vuetify.breakpoint.mdAndUp,
        'px-3': $vuetify.breakpoint.smAndDown
      }"
    >
      <v-col
        cols="12" md="4"
        v-for="(c,i) in cards" :key="i"
      >
        <v-card>
          <v-img
            :src="getImgUrl(c.imagem)"
            @click.stop="abreModal(c.vid)"
            style="cursor: pointer;"
          />
        </v-card>
      </v-col>
      <v-col
        cols="12" md="4"
        class="my-auto"
      >
        <v-card class="transparent text-center align-center fill-height">
          <div class="title white--text px-3">
            <span class="poppins">ESPERAMOS VER TAMBÉM O SEU DEPOIMENTO AQUI!</span>
          </div>
          <div class="">
            <v-btn
              outlined rounded
              color="primary"
              class="mt-4"
              @click="$vuetify.goTo('#mais-info')"
            >
              <span class="font-weight-bold">Participar</span>
            </v-btn>
          </div>
        </v-card>
        
      </v-col>
    </v-row>
    <v-row
      class="pt-6 text-center"
    >
      <v-col cols="12">
        <v-btn
          x-large
          color="primary"
          class="mt-4 mx-auto"
          @click="$vuetify.goTo('#mais-info')"
        >
          <span class="font-weight-bold">Inscreva-se</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="800"
    >
      <iframe v-if="dialog" id="iframeid" ref="iframe" width="100%" height="450" :src="src" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      atributosAdicionais: '?autoplay=1&enablejsapi=1',
      vidSelecionado: '',
      cards: [
        {
          imagem: '1.jpg',
          vid: 'tj9GI0Vmz9A' 
        },
        {
          imagem: '2.jpg',
          vid: 'Xueeg78e2vw'
        },
        {
          imagem: '3.jpg',
          vid: 'hWmEdpMULhs'
        },
        {
          imagem: '4.jpg',
          vid: 'VdFiD6nzjkQ'
        },
        {
          imagem: '5.jpg',
          vid: '_QNHVGHGan8'
        },
        {
          imagem: '6.jpg',
          vid: '60IQ_aqpLOg'
        },
        {
          imagem: '7.jpg',
          vid: 'Zqunxa6_QJA'
        },
      ]
    }
  },
  computed: {
    src: {
      get: function () {
        return 'https://www.youtube.com/embed/' + this.vidSelecionado + this.atributosAdicionais
      }
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/depoimentos/'+i)
    },
    abreModal(v) {
      this.dialog = true
      this.vidSelecionado = v
      //this.$refs.iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    }
  }
}
</script>